//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { goTo } from '@changba/funny';
import CommonMixins from './mixins.js';
import { get } from 'lodash-es';
import CbImage from '../image';
import { defineComponent } from '../utils/create';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "normal",
    class: {
      'with-bottom': _vm.hasOwn && _vm.showBottom
    }
  }, [_vm.$scopedSlots['top'] ? _vm._t("top", null, {
    "topList": _vm.pureTopList
  }) : _vm.highlightTop3 ? _c('div', {
    staticClass: "normal-top"
  }, _vm._l(_vm.topList, function (ref, idx) {
    var _obj;
    var data = ref.data;
    var className = ref.className;
    return _c('div', {
      key: 'top' + idx,
      staticClass: "normal-top-item",
      class: (_obj = {}, _obj[className] = true, _obj.mock = !data, _obj)
    }, [_c('div', {
      staticClass: "top-bg",
      attrs: {
        "data-idx": idx + 1
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "avatar",
      on: {
        "click": function ($event) {
          return _vm.goto(data, idx);
        }
      }
    }, [data ? _vm._t("top-avatar", function () {
      return [_c('cb-image', _vm._b({
        staticClass: "avatar-img",
        attrs: {
          "src": _vm.get(data, _vm.headphotoProp),
          "alt": "用户头像"
        }
      }, 'cb-image', _vm.imgConfig, false))];
    }, {
      "item": data,
      "index": idx
    }) : _c('span', {
      staticClass: "avatar-empty"
    }, [_vm._v(_vm._s(_vm.emptySeatText))])], 2), _vm._v(" "), _c('span', {
      staticClass: "score"
    }, [_vm._v("\n        " + _vm._s(data ? "" + _vm.formatScore(data[_vm.pointProp]) + _vm.unit : "0" + _vm.unit) + "\n      ")]), _vm._v(" "), _c('span', {
      staticClass: "nickname"
    }, [_vm._v("\n        " + _vm._s(data ? _vm.get(data, _vm.nicknameProp) : _vm.emptySeatText) + "\n      ")])]);
  }), 0) : _vm._e(), _vm._v(" "), _vm.normalList.length > 0 ? _c('div', {
    staticClass: "normal-wrapper"
  }, [_vm.showHeader ? _c('div', {
    staticClass: "normal-header"
  }, [_c('span', {
    staticClass: "normal-header__rank"
  }, [_vm._v("排名")]), _vm._v(" "), _c('span', {
    staticClass: "normal-header__avatar"
  }, [_vm._v("头像")]), _vm._v(" "), _c('span', {
    staticClass: "normal-header__nickname"
  }, [_vm._v("昵称")]), _vm._v(" "), _c('span', {
    staticClass: "normal-header__score"
  }, [_vm._v(_vm._s(_vm.headerScore))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "normal-container"
  }, _vm._l(_vm.normalList, function (row, rowIdx) {
    return _c('div', {
      key: 'row' + rowIdx,
      staticClass: "normal-item"
    }, [_c('span', {
      staticClass: "normal-item__rank",
      class: {
        plain: !_vm.highlightTop3
      },
      attrs: {
        "data-index": rowIdx
      }
    }, [_vm._v("\n          " + _vm._s(row[_vm.rankProp]) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "normal-item__avatar",
      on: {
        "click": function ($event) {
          return _vm.goto(row, rowIdx + 3);
        }
      }
    }, [_vm._t("item-avatar", function () {
      return [_c('cb-image', _vm._b({
        staticClass: "normal-item__avatar-img",
        attrs: {
          "src": _vm.get(row, _vm.headphotoProp),
          "data-src": _vm.get(row, _vm.headphotoProp),
          "alt": "用户头像"
        }
      }, 'cb-image', _vm.imgConfig, false))];
    }, {
      "item": row,
      "index": rowIdx + (_vm.highlightTop3 ? 3 : 0)
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "normal-item_content-wrapper"
    }, [_vm._t("item-content", function () {
      return [_c('span', {
        staticClass: "normal-item__nickname"
      }, [_vm._v("\n              " + _vm._s(_vm.get(row, _vm.nicknameProp) || '') + "\n            ")])];
    }, {
      "item": row,
      "index": rowIdx + (_vm.highlightTop3 ? 3 : 0)
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "normal-item_score-wrapper"
    }, [_vm._t("item-score", function () {
      return [_c('span', {
        staticClass: "normal-item__score"
      }, [_vm._v(" " + _vm._s(_vm.formatScore(row[_vm.pointProp] || 0)) + _vm._s(_vm.itemUnit) + " ")])];
    }, {
      "item": row,
      "index": rowIdx + (_vm.highlightTop3 ? 3 : 0)
    })], 2)]);
  }), 0)]) : _vm.normalList.length === 0 && _vm.selfShowEmptyText ? _c('div', {
    staticClass: "normal-empty"
  }, [_vm._v("\n    " + _vm._s(_vm.emptyText) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.hasOwn && _vm.showBottom ? _c('div', {
    staticClass: "normal-bottom",
    class: {
      'is-fixed': _vm.fixedBottom
    }
  }, [_c('div', {
    staticClass: "normal-bottom-inner"
  }, [_c('span', {
    staticClass: "normal-item__rank"
  }, [_vm._v(_vm._s(_vm.own[_vm.rankProp]))]), _vm._v(" "), _c('div', {
    staticClass: "normal-item__avatar"
  }, [_vm._t("bottom-avatar", function () {
    return [_c('cb-image', _vm._b({
      staticClass: "normal-item__avatar-img",
      attrs: {
        "src": _vm.get(_vm.own, _vm.headphotoProp),
        "alt": "用户头像"
      }
    }, 'cb-image', _vm.imgConfig, false))];
  }, {
    "own": _vm.own
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "normal-item_content-wrapper"
  }, [_vm._t("bottom-content", function () {
    return [_c('span', {
      staticClass: "normal-item__nickname"
    }, [_vm._v("\n            " + _vm._s(_vm.get(_vm.own, _vm.nicknameProp) || '') + "\n          ")])];
  }, {
    "own": _vm.own
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "normal-item_score-wrapper"
  }, [_vm._t("bottom-score", function () {
    return [_c('span', {
      staticClass: "normal-item__score"
    }, [_vm._v(" " + _vm._s(_vm.formatScore(_vm.own[_vm.pointProp] || 0)) + _vm._s(_vm.itemUnit) + " ")])];
  }, {
    "own": _vm.own
  })], 2)])]) : _vm._e()], 2);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-480d9ae3',
  render,
  name: 'CbNormalRank',
  components: {
    CbImage
  },
  mixins: [CommonMixins],
  props: {
    fieldsGetter: {
      type: [Object, Function],
      required: false,
      default: () => ({
        userid: 'userid',
        nickname: 'nickname',
        avatar: 'avatar',
        score: 'score',
        rank: 'rank'
      })
    }
  },
  computed: {
    headphotoProp() {
      return this.fieldsGetter.avatar;
    },
    useridProp() {
      return this.fieldsGetter.userid;
    },
    nicknameProp() {
      return this.fieldsGetter.nickname;
    },
    pointProp() {
      return this.fieldsGetter.score;
    },
    rankProp() {
      return this.fieldsGetter.rank;
    },
    pureTopList() {
      return this.topList.map(v => v.data);
    }
  },
  methods: {
    get(data, prop) {
      return get(data, ['detail', prop].join('.'));
    },
    goto(user, idx) {
      // emit goto事件出去，可将openUserProfile 设置false自行处理跳转
      var userId = this.get(user, this.fieldsGetter.userid);
      this.$emit('goto', {
        user: user ? userId : null,
        idx
      });
      if (!this.openUserProfile && typeof this.openUserProfile !== 'number') {
        return;
      }
      if (typeof this.openUserProfile === 'boolean' && this.openUserProfile) {
        goTo.profile(String(userId));
      } else if (typeof this.openUserProfile === 'number' && idx + 1 <= this.openUserProfile) {
        goTo.profile(String(userId));
      }
    }
  }
});